import { Show } from '@refinedev/antd';
import { useShow } from '@refinedev/core';
import { Descriptions, Alert, Button } from 'antd';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { MonoCode, formatDateBidi } from '@lebinatikra/rtl-utils';
import { DecisionTag } from './decision-tag';

interface AuditLogRecord {
  id: string;
  timestamp: string;
  action: string;
  filter_decision: string | null;
  user_id: string | null;
  community_id: string;
  organization_id: string | null;
}

export function AuditLogShow() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { query } = useShow<AuditLogRecord>({ resource: 'audit-log' });
  const record = query.data?.data;

  return (
    <Show isLoading={query.isLoading}>
      {record ? (
        <>
          <Descriptions column={1} bordered>
            <Descriptions.Item label={t('common.id')}>
              <MonoCode>{record.id}</MonoCode>
            </Descriptions.Item>
            <Descriptions.Item label={t('auditLog.columns.timestamp')}>
              {formatDateBidi(record.timestamp)}
            </Descriptions.Item>
            <Descriptions.Item label={t('auditLog.columns.action')}>
              {record.action}
            </Descriptions.Item>
            <Descriptions.Item label={t('auditLog.columns.filterDecision')}>
              <DecisionTag value={record.filter_decision} />
            </Descriptions.Item>
            <Descriptions.Item label={t('auditLog.columns.userId')}>
              {record.user_id ? <MonoCode>{record.user_id}</MonoCode> : '—'}
            </Descriptions.Item>
            <Descriptions.Item label={t('auditLog.columns.community')}>
              <MonoCode>{record.community_id}</MonoCode>
            </Descriptions.Item>
            <Descriptions.Item label={t('auditLog.columns.organization')}>
              {record.organization_id ? (
                <MonoCode>{record.organization_id}</MonoCode>
              ) : (
                '—'
              )}
            </Descriptions.Item>
          </Descriptions>
          <Alert
            type="info"
            message={t('auditLog.privacyNotice')}
            style={{ marginTop: 16 }}
          />
          <Button style={{ marginTop: 16 }} onClick={() => navigate(-1)}>
            {t('common.back')}
          </Button>
        </>
      ) : null}
    </Show>
  );
}
